import React from 'react';
import { createStyles, Box, Text, Title, List } from '@mantine/core';

function TosPlainText({ children, language = 'en', ...otherProps }) {
  const { classes } = useStyles();

  if (language === 'pl')
    return (
      <Box className={classes.container} {...otherProps}>
        <Text size="sm" py={10}>
          Prosimy o uważne przeczytanie poniższego Regulaminu korzystania z
          aplikacji ("Regulamin"). Niniejszy Regulamin reguluje korzystanie
          przez Ciebie z aplikacji mobilnej Say Help, LLC ("Say Help")
          ("Aplikacja"). Jeśli nie zgadzasz się na przestrzeganie niniejszego
          Regulaminu, natychmiast usuń i zaprzestań korzystania z Aplikacji.
        </Text>
        <Text size="sm" py={10}>
          Say Help zastrzega sobie prawo do zmiany Regulaminu, według własnego
          uznania, w dowolnym momencie i bez powiadomienia. Wszystkie zmiany
          Regulaminu obowiązują od daty ich opublikowania.
        </Text>
        <Title order={4} py={10}>
          Rejestracja w Aplikacji
        </Title>
        <Text size="sm" py={10}>
          Aplikacja wykorzystuje nowoczesną technologię do wysyłania wiadomości
          SMS i/lub alertu alarmowego do Publicznego Punktu Odpowiedzi na
          Zgłoszenia (PSAP), wskazując Twoją aktualną lokalizację, GPS oraz
          informacje profilowe w przypadku wydania komendy głosowej POMOC POMOC
          POMOC lub innej komendy rozpoznanej przez Say Help ("Komenda
          głosowa"). Aby uzyskać dostęp i korzystać z Aplikacji, musisz założyć
          konto użytkownika ("Twoje Konto") i przestrzegać niniejszego
          Regulaminu. Zakładając i utrzymując Konto, zobowiązujesz się do
          podawania prawdziwych informacji dotyczących swojej tożsamości, danych
          kontaktowych oraz innych informacji wymaganych przez Say Help.
          Ustawiasz własne hasło do korzystania z Usługi i ponosisz pełną
          odpowiedzialność za wszystko, co dzieje się za pośrednictwem Twojego
          Konta.
        </Text>
        <Title order={4} py={10}>
          Korzystanie z Aplikacji
        </Title>
        <Text size="sm" py={10}>
          Aplikacja może być używana wyłącznie w sposób zgodny z prawem i
          odpowiedni. Say Help zastrzega sobie prawo do wprowadzania zmian w
          Aplikacji w dowolnym momencie i bez powiadomienia. Twój dostęp do
          Aplikacji oraz korzystanie z niej mogą zostać zablokowane, zawieszone
          lub zakończone bez wcześniejszego powiadomienia, w dowolnym momencie,
          z dowolnego powodu lub bez powodu. Poniższa lista nie jest
          wyczerpująca, ale Twój dostęp do Aplikacji może zostać ograniczony lub
          cofnięty przez Say Help w przypadku naruszenia poniższych zasad:
        </Text>
        <List
          withPadding
          size="sm"
          style={{
            listStylePosition: 'outside',
          }}>
          <List.Item py={10}>
            Musisz przestrzegać wszystkich obowiązujących przepisów prawa
            krajowego, międzynarodowego, regulaminów, polityk i/lub licencji
            dotyczących komunikacji podczas korzystania z Aplikacji.
          </List.Item>
          <List.Item py={10}>
            Nie możesz używać Aplikacji w sposób niewłaściwy, np. do wzywania
            służb ratunkowych, gdy nie jest to wymagane, ani do nękania lub
            prześladowania innych osób.
          </List.Item>
          <List.Item py={10}>
            Nie możesz zakłócać ani próbować zakłócać działania Aplikacji lub
            korzystania z niej przez inne osoby za pomocą jakiegokolwiek
            programu, skryptu, polecenia, urządzenia, oprogramowania, procedury
            lub w inny sposób.
          </List.Item>
          <List.Item py={10}>
            Nie możesz próbować uzyskać nieautoryzowanego dostępu do żadnej
            części lub funkcji Aplikacji, ani korzystać z niej w sposób
            wykraczający poza zakres uprawnień przyznanych przez Say Help.
          </List.Item>
          <List.Item py={10}>
            Nie możesz kopiować, dekompilować ani dokonywać inżynierii wstecznej
            Aplikacji (ani żadnych algorytmów użytych do jej stworzenia) ani
            tworzyć dzieł pochodnych na jej podstawie.
          </List.Item>
          <List.Item py={10}>
            Nie możesz używać Aplikacji w celu opracowania aplikacji o podobnym
            charakterze lub przeznaczeniu.
          </List.Item>
          <List.Item py={10}>
            Nie możesz podejmować żadnych działań, które według wyłącznego
            uznania Say Help stanowią nadużycie Aplikacji.
          </List.Item>
        </List>
        <Title order={4} py={10}>
          Licencja
        </Title>
        <Text size="sm" py={10}>
          Say Help udziela Ci ograniczonej, niewyłącznej i nieprzenoszalnej
          licencji na dostęp i korzystanie z Aplikacji. Każde nieautoryzowane
          użycie Aplikacji skutkuje automatycznym cofnięciem udzielonej
          licencji. Ponadto Say Help zastrzega sobie prawo do cofnięcia tej
          licencji w dowolnym momencie i z dowolnego powodu. Wszystkie prawa do
          Aplikacji, które nie zostały wyraźnie przyznane w niniejszym
          Regulaminie, pozostają zastrzeżone na wyłączność Say Help. Nie
          nabywasz żadnych praw, tytułów ani udziałów w Aplikacji na mocy
          niniejszego Regulaminu, poza niewyłączną licencją na korzystanie z
          Aplikacji zgodnie z Regulaminem.
        </Text>
        <Title order={4} py={10}>
          Opinie i wyniki
        </Title>
        <Text size="sm" py={10}>
          Możesz zostać poproszony o przekazanie pomysłów, sugestii lub opinii
          dotyczących korzystania z Aplikacji (łącznie "Opinie"), które Say Help
          może wykorzystać do ulepszania Aplikacji. Ponadto Say Help może
          śledzić i agregować informacje dotyczące korzystania przez Ciebie z
          Aplikacji (łącznie "Wyniki"). Zgadzasz się, że nie będziesz zgłaszać
          żadnych roszczeń o wynagrodzenie związane z wykorzystaniem przez Say
          Help jakichkolwiek Opinii lub Wyników, ani nie będziesz rościć sobie
          żadnych praw własności do Opinii lub Wyników.
        </Text>
        <Title order={4} py={10}>
          Wyłączenie odpowiedzialności z tytułu gwarancji
        </Title>
        <Text size="sm" py={10}>
          MIMO ŻE SAY HELP DOŁOŻY STARAŃ, ABY APLIKACJA DZIAŁAŁA ZGODNIE Z
          PRZEZNACZENIEM, SAY HELP NIE GWARANTUJE, ŻE APLIKACJA BĘDZIE DZIAŁAĆ
          WE WSZYSTKICH OKOLICZNOŚCIACH. W SZCZEGÓLNOŚCI APLIKACJA WYMAGA, ABY
          TWOJE URZĄDZENIE MOBILNE MIAŁO: (1) SYGNAŁ SIECIOWY DO WYSŁANIA
          WIADOMOŚCI SMS; (2) INFORMACJE O LOKALIZACJI GPS ORAZ (3) POŁĄCZENIE
          DANYCH. W PRZYPADKU BRAKU KTÓREJKOLWIEK Z TYCH TRZECH RZECZY,
          APLIKACJA NIE BĘDZIE DZIAŁAĆ ZGODNIE Z ZAŁOŻENIAMI. MOGĄ ISTNIEĆ INNE
          OKOLICZNOŚCI, KTÓRE SPOWODUJĄ, ŻE APLIKACJA NIE ROZPOZNA TWOJEJ
          KOMENDY GŁOSOWEJ. SAY HELP NIE PONOSI ODPOWIEDZIALNOŚCI ZA DZIAŁANIE
          TWOJEGO URZĄDZENIA MOBILNEGO, JEGO ZDOLNOŚĆ DO WSPÓŁPRACY Z APLIKACJĄ
          ANI ZA ZDOLNOŚĆ APLIKACJI DO ROZPOZNAWANIA TWOJEJ KOMENDY GŁOSOWEJ W
          DANYCH OKOLICZNOŚCIACH. TO WYŁĄCZNIE TWOJA ODPOWIEDZIALNOŚĆ, ABY
          ZAPEWNIĆ, ŻE TWOJE URZĄDZENIE I POŁĄCZENIE SĄ ZAWSZE WYSTARCZAJĄCE.
        </Text>
        <Text size="sm" py={10}>
          W MAKSYMALNYM ZAKRESIE DOZWOLONYM PRZEZ PRAWO, APLIKACJA JEST
          DOSTARCZANA "TAK JAK JEST", BEZ JAKIEJKOLWIEK GWARANCJI, WYRAŹNEJ LUB
          DOROZUMIANEJ. SAY HELP NIE GWARANTUJE, NIE OŚWIADCZA ANI NIE ZAPEWNIA,
          ŻE KORZYSTANIE Z APLIKACJI BĘDZIE NIEPRZERWANE, WOLNE OD BŁĘDÓW LUB
          WIRUSÓW, ANI ŻE APLIKACJA SPEŁNI TWOJE WYMAGANIA. SAY HELP WYŁĄCZA
          WSZELKIE GWARANCJE, WYRAŹNE LUB DOROZUMIANE, W TYM MIĘDZY INNYMI
          GWARANCJE TYTUŁU, NIENARUSZANIA PRAW, PRZYDATNOŚCI HANDLOWEJ,
          PRZYDATNOŚCI DO OKREŚLONEGO CELU LUB JAKIEJKOLWIEK GWARANCJI
          WYNIKAJĄCEJ Z PRZEBIEGU TRANSAKCJI, ZWYCZAJU HANDLOWEGO LUB PRAKTYKI.
        </Text>
        <Title order={4} py={10}>
          Ograniczenie odpowiedzialności
        </Title>
        <Text size="sm" py={10}>
          POTWIERDZASZ I ZGADZASZ SIĘ, ŻE KORZYSTASZ Z APLIKACJI NA WŁASNE
          RYZYKO. ANI SAY HELP, ANI ŻADEN Z JEGO CZŁONKÓW, ZARZĄDCÓW,
          PRACOWNIKÓW, PODMIOTÓW POWIĄZANYCH, AGENTÓW, PRZEDSTAWICIELI,
          LICENCJODAWCÓW, NASTĘPCÓW PRAWNYCH LUB CESJONARIUSZY (ŁĄCZNIE
          "PODMIOTY POWIĄZANE Z SAY HELP") NIE PONOSZĄ ODPOWIEDZIALNOŚCI WOBEC
          CIEBIE ZA JAKIEKOLWIEK ODSZKODOWANIA, BEZPOŚREDNIE, POŚREDNIE,
          PRZYPADKOWE, SZCZEGÓLNE, PRZYKŁADOWE, KARNE LUB WTÓRNE, ANI ZA KOSZTY
          OBSŁUGI PRAWNEJ, UTRATĘ DANYCH LUB UTRATĘ ZYSKÓW WYNIKAJĄCYCH Z: (A)
          KORZYSTANIA Z APLIKACJI; (B) NIEMOŻNOŚCI UZYSKANIA DOSTĘPU LUB
          KORZYSTANIA Z APLIKACJI; I/LUB (C) NARUSZENIA NINIEJSZEGO REGULAMINU
          PRZEZ SAY HELP.
        </Text>
        <Text size="sm" py={10}>
          POWYŻSZE WYŁĄCZENIA ODPOWIEDZIALNOŚCI MAJĄ ZASTOSOWANIE NAWET JEŚLI
          SAY HELP ZOSTAŁO POINFORMOWANE O MOŻLIWOŚCI WYSTĄPIENIA TAKICH SZKÓD
          LUB BYŁY ONE PRZEWIDYWALNE. TWOIM JEDYNYM PRAWEM I ŚRODKIEM OCHRONY W
          PRZYPADKU SPORU Z SAY HELP JEST ZAPRZESTANIE KORZYSTANIA Z APLIKACJI.
          PONIEWAŻ NIEKTÓRE PAŃSTWA LUB JURYSDYKCJE NIE ZEZWALAJĄ NA WYŁĄCZENIE
          LUB OGRANICZENIE ODPOWIEDZIALNOŚCI ZA SZKODY WTÓRNE, PRZYPADKOWE LUB
          SZCZEGÓLNE, W TAKICH PAŃSTWACH I JURYSDYKCJACH ODPOWIEDZIALNOŚĆ JEST
          OGRANICZONA DO NAJSZERSZEGO ZAKRESU DOZWOLONEGO PRZEZ PRAWO.
        </Text>
        <Title order={4} py={10}>
          Odszkodowanie
        </Title>
        <Text size="sm" py={10}>
          Zobowiązujesz się zabezpieczyć, bronić i zwolnić z odpowiedzialności
          Say Help oraz podmioty powiązane z Say Help od wszelkich strat,
          zobowiązań, wydatków, szkód, roszczeń, żądań i kosztów, w tym
          uzasadnionych kosztów obsługi prawnej i kosztów sądowych, związanych z
          lub wynikających z: (a) jakiegokolwiek naruszenia niniejszego
          Regulaminu przez Ciebie; oraz (b) roszczeń zgłaszanych przez osoby
          trzecie, takie jak organy ścigania, wynikających z korzystania przez
          Ciebie z Aplikacji.
        </Text>
        <Title order={4} py={10}>
          Polityka prywatności
        </Title>
        <Text size="sm" py={10}>
          Say Help szanuje i zobowiązuje się do ochrony Twojej prywatności.
          Zapoznaj się z Polityką prywatności Say Help{' '}
          <a
            href="https://sayhelp.com/privacy/pl"
            target="_blank"
            rel="noreferrer">
            Polityka prywatności
          </a>
          , która również reguluje korzystanie z Aplikacji, aby zrozumieć
          praktyki Say Help.
        </Text>
        <Title order={4} py={10} align="left">
          Postanowienia końcowe
        </Title>
        <Text size="sm" py={10}>
          Prawo stanu Wyoming reguluje ważność, wykonanie, egzekwowanie,
          interpretację i wszelkie inne aspekty niniejszego Regulaminu, bez
          względu na zasady kolizji praw. Strony zgadzają się poddać wyłącznej
          jurysdykcji i właściwości sądów hrabstwa Johnson, Wyoming, w przypadku
          wszelkich sporów wynikających z niniejszego Regulaminu. Say Help ma
          prawo do zwrotu wszelkich kosztów poniesionych w związku z
          egzekwowaniem niniejszego Regulaminu, w tym kosztów obsługi prawnej.
        </Text>
        <Text size="sm" py={10}>
          Potwierdzasz i zgadzasz się, że postanowienia, ujawnienia i wyłączenia
          odpowiedzialności określone w niniejszym Regulaminie są uczciwe i
          rozsądne, a Twoja zgoda na ich przestrzeganie nie jest wynikiem
          oszustwa, przymusu ani niewłaściwego wpływu ze strony jakiejkolwiek
          osoby lub podmiotu. Brak egzekwowania przez Say Help jakiegokolwiek
          prawa lub postanowienia Regulaminu nie stanowi zrzeczenia się takiego
          prawa lub postanowienia. Jeśli jakiekolwiek postanowienie Regulaminu
          zostanie uznane przez sąd za nieważne, strony zgadzają się, że sąd
          powinien dążyć do realizacji intencji stron wyrażonej w tym
          postanowieniu, a pozostałe postanowienia Regulaminu pozostają w pełnej
          mocy.
        </Text>
        <Text size="sm" py={10}>
          Say Help ma prawo przenieść niniejszy Regulamin oraz udzielić
          sublicencji na wszelkie swoje prawa wynikające z Regulaminu. Niniejszy
          Regulamin, w tym dokumenty, do których się odwołuje, oraz wszelkie
          dodatkowe warunki opublikowane za pośrednictwem Aplikacji, stanowią
          całość porozumienia między Tobą a Say Help w odniesieniu do Aplikacji.
          Regulamin zastępuje wszelkie wcześniejsze pisemne lub ustne umowy
          dotyczące tego przedmiotu. Niezależnie od jakichkolwiek postanowień
          Regulaminu, Say Help ma do dyspozycji wszelkie środki prawne lub
          służące ochronie prawnej w celu egzekwowania Regulaminu.
        </Text>
        <Text size="sm" py={10}></Text>
      </Box>
    );

  if (language === 'es')
    return (
      <Box className={classes.container} {...otherProps}>
        <Text size="sm" py={10}>
          Lea atentamente los siguientes Términos de uso ("Términos"). Estos
          Términos regirán su uso de la aplicación móvil Say Help, LLC ("Say
          Help") (la "Aplicación"). Si no acepta estar sujeto a estos Términos,
          elimine de inmediato y cese todo uso de la Aplicación.
        </Text>

        <Text size="sm" py={10}>
          Say Help se reserva el derecho de cambiar los Términos bajo los cuales
          se ofrece la Aplicación a su exclusivo y absoluto criterio en
          cualquier momento y sin previo aviso. Todos los cambios a los Términos
          son efectivos a partir de la fecha de publicación.
        </Text>
        <Title order={4} py={10}>
          Registro para la Aplicación
        </Title>
        <Text size="sm" py={10}>
          La Aplicación utiliza tecnología actual para enviar un mensaje de
          texto y/o una alerta de emergencia a un Punto de Respuesta de
          Seguridad Pública (PSAP) indicando su ubicación actual, GPS e
          información de perfil en caso de que usted dé AYUDA AYUDA AYUDA o otro
          comando de voz identificado por Say Help (el "Comando de voz"). Para
          acceder y utilizar la Aplicación, debe configurar una cuenta de
          usuario ("Su Cuenta") y cumplir con estos Términos. Al configurar y
          mantener su cuenta, acepta proporcionar información precisa sobre su
          identidad, su información de contacto y cualquier otra información
          solicitada por Say Help. Establecerá su propia contraseña para acceder
          al Servicio y será el único y estricto responsable de todo lo que
          ocurra a través del uso de Su Cuenta.
        </Text>
        <Title order={4} py={10}>
          Uso de la Aplicación
        </Title>
        <Text size="sm" py={10}>
          La Aplicación solo puede utilizarse para usos legales y apropiados.
          Say Help se reserva el derecho de realizar cambios en la Aplicación en
          cualquier momento y sin previo aviso. Su acceso y uso de la Aplicación
          puede bloquearse, suspenderse o cancelarse sin previo aviso en
          cualquier momento por cualquier motivo o sin motivo alguno. Aunque la
          siguiente lista no es exhaustiva, su acceso a la Aplicación puede ser
          limitado o revocado por Say Help en cualquier momento por cualquier
          violación de las siguientes reglas:
        </Text>
        <List
          withPadding
          size="sm"
          style={{
            listStylePosition: 'outside',
          }}>
          <List.Item py={10}>
            Debe cumplir con todas las leyes, reglas, leyes estatales, federales
            y/o internacionales. políticas y/o licencias que rigen las
            comunicaciones durante el uso de la Aplicación.
          </List.Item>
          <List.Item py={10}>
            No puede usar la Aplicación de manera inapropiada, como para
            solicitar servicios de emergencias cuando tales servicios no son
            requeridos, o para golpear o acosar a otros.
          </List.Item>
          <List.Item py={10}>
            No puede interferir o intentar interferir con la Aplicación o el uso
            de la Aplicación por parte de otra persona mediante el uso de
            cualquier programa, script, comando, dispositivo, software, rutina o
            de otro modo.
          </List.Item>
          <List.Item py={10}>
            No puede intentar obtener acceso no autorizado a ninguna parte o
            función de la Aplicación, ni intentar usar la Aplicación de otra
            manera que exceda los límites de los derechos que Say Help ha
            otorgado en este documento.
          </List.Item>
          <List.Item py={10}>
            No puede copiar, descompilar ni realizar ingeniería inversa de la
            Aplicación (y/o cualquier algoritmo utilizado para crear la
            Aplicación) y/o crear trabajos derivados basados ​​en la Aplicación.
          </List.Item>
          <List.Item py={10}>
            No puede usar la Aplicación con el fin de desarrollar una aplicación
            que sea similar en naturaleza o propósito a la Aplicación
          </List.Item>
          <List.Item py={10}>
            No puede participar en ninguna actividad que constituya, a exclusivo
            criterio de Say Help, un abuso de la Aplicación.
          </List.Item>
        </List>

        <Title order={4} py={10}>
          Licencia
        </Title>
        <Text size="sm" py={10}>
          Say Help le otorga una licencia limitada, no exclusiva e
          intransferible para acceder y utilizar la Aplicación. Cualquier uso no
          autorizado de la Aplicación rescindirá automáticamente la licencia que
          se le otorga en este documento. Además, Say Help se reserva el derecho
          de revocar esta licencia en cualquier momento y por cualquier motivo.
          Todos los derechos sobre la Aplicación que no se concedan expresamente
          en el presente se considerarán reservados para el uso exclusivo de Say
          Help. No adquirirá ningún derecho, título o interés en la Aplicación
          en virtud de estos Términos, excepto la licencia no exclusiva para
          usar la Aplicación de acuerdo con estos Términos.
        </Text>

        <Title order={4} py={10}>
          Comentarios y resultados
        </Title>
        <Text size="sm" py={10}>
          Es posible que se le solicite que brinde ideas, sugerencias o
          comentarios relacionados con su uso de la Aplicación (colectivamente,
          los "Comentarios"), que Say Help puede utilizar para mejorar la
          Aplicación. Además, Say Help puede rastrear y agregar información
          relacionada con su uso de la Aplicación (colectivamente, los
          "Resultados"). Usted acepta que no deberá hacer ningún reclamo de
          compensación relacionado con el uso de Say Help de los Comentarios o
          Resultados, ni reclamará ningún derecho de propiedad sobre los
          Comentarios o Resultados.
        </Text>

        <Title order={4} py={10}>
          Descargo de responsabilidad de garantías.
        </Title>
        <Text size="sm" py={10}>
          MIENTRAS QUE SAY HELP SE ESFUERZA POR GARANTIZAR QUE LA APLICACIÓN
          FUNCIONARÁ SEGÚN LO PREVISTO, SAY HELP NO GARANTIZA QUE LA APLICACIÓN
          SIEMPRE FUNCIONARÁ EN TODAS LAS CIRCUNSTANCIAS. EN PARTICULAR, LA
          APLICACIÓN DEPENDE DE QUE SU DISPOSITIVO MÓVIL TENGA: (1) UNA SEÑAL
          CELULAR PARA ENVIAR UN MENSAJE DE TEXTO; (2) INFORMACIÓN DE UBICACIÓN
          GPS Y (3) UNA CONEXIÓN DE DATOS. EN AUSENCIA DE CUALQUIERA DE ESTOS
          TRES CRITERIOS, LA APLICACIÓN NO FUNCIONARÁ COMO SE HA DISEÑADO.
          ADEMÁS, PUEDE HABER OTRAS CIRCUNSTANCIAS PRESENTES QUE PROVOQUEN QUE
          LA APLICACIÓN NO RECONOZCA SU COMANDO DE VOZ. SAY HELP NO ASUME
          RESPONSABILIDAD POR SI Y/O CÓMO FUNCIONA SU DISPOSITIVO MÓVIL, LA
          CAPACIDAD DE SU DISPOSITIVO MÓVIL PARA TRABAJAR CON LA APLICACIÓN, O
          LA CAPACIDAD DE LA APLICACIÓN PARA RECONOCER SU COMANDO DE VOZ EN UNA
          CIRCUNSTANCIA DADA. ES ÚNICAMENTE SU RESPONSABILIDAD ASEGURARSE DE QUE
          SU DISPOSITIVO MÓVIL Y SU CONEXIÓN SEAN SUFICIENTES EN TODO MOMENTO.
        </Text>
        <Text size="sm" py={10}>
          EN LA MEDIDA EN QUE LO PERMITA LA LEY APLICABLE, LA APLICACIÓN SE
          PROPORCIONA "TAL CUAL", SIN GARANTÍA DE NINGÚN TIPO, YA SEA EXPLÍCITA
          O IMPLÍCITA. SAY HELP NO GARANTIZA, REPRESENTA O GARANTIZA QUE EL USO
          DE LA APLICACIÓN SERÁ ININTERRUMPIDO, LIBRE DE ERRORES O VIRUS, O QUE
          LA APLICACIÓN CUMPLIRÁ CON SUS REQUISITOS. SAY HELP NIEGA TODAS LAS
          GARANTÍAS, EXPRESAS O IMPLÍCITAS, INCLUYENDO, ENTRE OTRAS, CUALQUIER
          GARANTÍA DE TÍTULO, NO INFRACCIÓN, COMERCIABILIDAD, IDONEIDAD PARA UN
          FIN DETERMINADO O CUALQUIER GARANTÍA QUE SURJA DE UN CURSO DE
          NEGOCIACIÓN, USO COMERCIAL O PRÁCTICA COMERCIAL.
        </Text>

        <Title order={4} py={10}>
          Limitación de responsabilidad.
        </Title>
        <Text size="sm" py={10}>
          USTED RECONOCE Y ACEPTA QUE EL USO DE LA APLICACIÓN ES BAJO SU PROPIO
          RIESGO. NI SAY HELP, NI NINGUNO DE SUS MIEMBROS, GERENTES, EMPLEADOS,
          AFILIADOS, AGENTES, REPRESENTANTES, LICENCIANTES, SUCESORES O
          CESIONARIOS (COLECTIVAMENTE, “SAY HELP ASOCIADOS”) SERÁN RESPONSABLES
          ANTE USTED POR CUALQUIER CUALQUIER COMPENSACIÓN, DIRECTA, INDIRECTA,
          INCIDENTAL, DAÑOS ESPECIALES, EJEMPLARES, PUNITIVOS O CONSECUENTES U
          HONORARIOS DE ABOGADOS O POR PÉRDIDA DE DATOS O PÉRDIDA DE BENEFICIOS
          QUE SURJAN DE: (A) EL USO DE LA APLICACIÓN; (B) LA IMPOSIBILIDAD DE
          OBTENER ACCESO O UTILIZAR LA APLICACIÓN; Y/O (C) DIGA AYUDA AL
          INCUMPLIMIENTO DE ESTOS TÉRMINOS.
        </Text>
        <Text size="sm" py={10}>
          LAS ANTERIORES EXCLUSIONES DE RESPONSABILIDAD SE APLICARÁN INCLUSO SI
          SAY HELP HA SIDO ADVERTIDO DE LA POSIBILIDAD DE TALES DAÑOS O TALES
          DAÑOS FUERON PREVISIBLES. SU ÚNICO DERECHO Y RECURSO CON RESPECTO A
          CUALQUIER DISPUTA CON SAY HELP ES DEJAR DE UTILIZAR LA APLICACIÓN.
          DEBIDO A QUE ALGUNOS ESTADOS O JURISDICCIONES NO PERMITEN LA EXCLUSIÓN
          O LIMITACIÓN DE RESPONSABILIDAD POR DAÑOS CONSECUENTES, INCIDENTALES O
          ESPECIALES, EN DICHOS ESTADOS Y JURISDICCIONES LA RESPONSABILIDAD SE
          LIMITA A LA MÁXIMA MEDIDA PERMITIDA POR LA LEY.
        </Text>

        <Title order={4} py={10}>
          Indemnización.
        </Title>
        <Text size="sm" py={10}>
          Usted acepta indemnizar, defender y eximir de responsabilidad a Say
          Help y a los asociados de Say Help de todas las pérdidas,
          responsabilidades, gastos, daños, reclamaciones, demandas y costos,
          incluidos los honorarios razonables de abogados y los costos
          judiciales, relacionados con o que surjan de: (a) cualquier violación
          de estos Términos por su parte; y (b) reclamos presentados por
          terceros, como la aplicación de la ley, que resultan de su uso de la
          Aplicación.
        </Text>

        <Title order={4} py={10}>
          Política de privacidad.
        </Title>
        <Text size="sm" py={10}>
          Say Help respeta y se compromete con su privacidad. Revise la Política
          de privacidad de Say Help{' '}
          <a
            href="https://sayhelp.com/privacy/es"
            target="_blank"
            rel="noreferrer">
            Política de privacidad
          </a>
          , que también rige su uso de la Aplicación, para comprender las
          prácticas de Say Help.
        </Text>

        <Title order={4} py={10} align="left">
          Miceláneas.
        </Title>
        <Text size="sm" py={10}>
          Las leyes del Estado de Wyoming regirán la validez, ejecución,
          cumplimiento, interpretación y cualquier otro aspecto de estos
          Términos, sin tener en cuenta los principios de conflicto de leyes en
          virtud de los mismos. Las partes acuerdan someterse a la jurisdicción
          y competencia exclusivas de los tribunales del condado de Johnson,
          Wyoming, para cualquier acción que surja de estos Términos. Say Help
          tendrá derecho a que usted le pague todos y cada uno de los gastos de
          bolsillo, incluidos, entre otros, los honorarios de abogados,
          incurridos por Say Help en relación con el cumplimiento de estos
          Términos.
        </Text>
        <Text size="sm" py={10}>
          Usted reconoce y acepta que las disposiciones, las divulgaciones y las
          exenciones de responsabilidad establecidas en estos Términos son
          justas y razonables y su acuerdo de seguirlos y estar sujeto a ellos
          no es el resultado de fraude, coacción o influencia indebida ejercida
          sobre usted por parte de cualquier persona o entidad. El hecho de que
          Say Help no ejerza o haga cumplir cualquier derecho o disposición de
          estos Términos no constituirá una renuncia a tal derecho o
          disposición. Si un tribunal de jurisdicción competente determina que
          alguna disposición de estos Términos no es válida, las partes
          acuerdan, sin embargo, que el tribunal debe esforzarse por hacer
          efectivas las intenciones de las partes tal como se refleja en la
          disposición, y las demás disposiciones de los Términos permanecerán en
          total fuerza y ​​efecto.
        </Text>

        <Text size="sm" py={10}>
          Say Help tendrá el derecho de asignar estos Términos y sublicenciar
          cualquiera y todos sus derechos bajo estos Términos. Estos Términos,
          incluidos los documentos a los que se hace referencia en este
          documento y los términos y condiciones adicionales publicados a través
          de la Aplicación, representan el entendimiento total entre usted y Say
          Help con respecto a la Aplicación. Estos Términos reemplazan todos los
          acuerdos escritos u orales anteriores entre usted y Say Help con
          respecto a dicho tema. Sin perjuicio de cualquier disposición de estos
          Términos, Say Help tiene disponibles todos los recursos legales o de
          equidad para hacer cumplir estos Términos.
        </Text>
        <Text size="sm" py={10}></Text>
      </Box>
    );

  if (language === 'it')
    return (
      <Box className={classes.container} {...otherProps}>
        <Text size="sm" py={10}>
          Si prega di leggere attentamente i seguenti Termini di utilizzo
          ("Termini"). Questi Termini regolano l'utilizzo dell'applicazione
          mobile Say Help, LLC ("Say Help") (l'"Applicazione"). Se non accetti
          di essere vincolato da questi Termini, elimina immediatamente e
          interrompi l'utilizzo dell'Applicazione.
        </Text>
        <Text size="sm" py={10}>
          Say Help si riserva il diritto di modificare i Termini a sua esclusiva
          discrezione in qualsiasi momento e senza preavviso. Tutte le modifiche
          ai Termini sono efficaci dalla data di pubblicazione.
        </Text>
        <Title order={4} py={10}>
          Registrazione all'Applicazione
        </Title>
        <Text size="sm" py={10}>
          L'Applicazione utilizza tecnologie moderne per inviare un messaggio di
          testo e/o un avviso di emergenza a un Centro di Risposta per la
          Sicurezza Pubblica (PSAP) indicando la tua posizione attuale, GPS e
          informazioni del profilo nel caso in cui tu dia il comando vocale
          AIUTO AIUTO AIUTO o altro comando vocale identificato da Say Help (il
          "Comando vocale"). Per accedere e utilizzare l'Applicazione, devi
          creare un account utente ("Il tuo Account") e rispettare questi
          Termini. Creando e mantenendo il tuo Account, accetti di fornire
          informazioni accurate sulla tua identità, sui tuoi dati di contatto e
          su qualsiasi altra informazione richiesta da Say Help. Imposterai la
          tua password per accedere al Servizio e sarai l'unico e diretto
          responsabile di tutto ciò che avviene tramite l'uso del tuo Account.
        </Text>
        <Title order={4} py={10}>
          Utilizzo dell'Applicazione
        </Title>
        <Text size="sm" py={10}>
          L'Applicazione può essere utilizzata solo per scopi legali e
          appropriati. Say Help si riserva il diritto di apportare modifiche
          all'Applicazione in qualsiasi momento e senza preavviso. Il tuo
          accesso e utilizzo dell'Applicazione può essere bloccato, sospeso o
          terminato senza preavviso in qualsiasi momento per qualsiasi motivo o
          senza motivo. Sebbene il seguente elenco non sia esaustivo, il tuo
          accesso all'Applicazione può essere limitato o revocato da Say Help in
          qualsiasi momento per qualsiasi violazione delle seguenti regole:
        </Text>
        <List
          withPadding
          size="sm"
          style={{
            listStylePosition: 'outside',
          }}>
          <List.Item py={10}>
            Devi rispettare tutte le leggi, regolamenti, politiche e/o licenze
            nazionali, federali e/o internazionali che regolano le comunicazioni
            durante l'utilizzo dell'Applicazione.
          </List.Item>
          <List.Item py={10}>
            Non puoi utilizzare l'Applicazione in modo improprio, ad esempio per
            richiedere servizi di emergenza quando tali servizi non sono
            necessari, o per molestare o perseguitare altri.
          </List.Item>
          <List.Item py={10}>
            Non puoi interferire o tentare di interferire con l'Applicazione o
            con l'utilizzo dell'Applicazione da parte di un'altra persona
            tramite qualsiasi programma, script, comando, dispositivo, software,
            routine o altro.
          </List.Item>
          <List.Item py={10}>
            Non puoi tentare di ottenere accesso non autorizzato a qualsiasi
            parte o funzione dell'Applicazione, né tentare di utilizzare
            l'Applicazione in modo che superi i limiti dei diritti concessi da
            Say Help nel presente documento.
          </List.Item>
          <List.Item py={10}>
            Non puoi copiare, decompilare o effettuare reverse engineering
            dell'Applicazione (e/o di qualsiasi algoritmo utilizzato per
            crearla) e/o creare opere derivate basate sull'Applicazione.
          </List.Item>
          <List.Item py={10}>
            Non puoi utilizzare l'Applicazione allo scopo di sviluppare
            un'applicazione simile per natura o scopo all'Applicazione.
          </List.Item>
          <List.Item py={10}>
            Non puoi impegnarti in alcuna attività che, a esclusiva discrezione
            di Say Help, costituisca un abuso dell'Applicazione.
          </List.Item>
        </List>
        <Title order={4} py={10}>
          Licenza
        </Title>
        <Text size="sm" py={10}>
          Say Help ti concede una licenza limitata, non esclusiva e non
          trasferibile per accedere e utilizzare l'Applicazione. Qualsiasi
          utilizzo non autorizzato dell'Applicazione comporterà la revoca
          automatica della licenza concessa. Inoltre, Say Help si riserva il
          diritto di revocare questa licenza in qualsiasi momento e per
          qualsiasi motivo. Tutti i diritti sull'Applicazione non espressamente
          concessi nel presente documento sono riservati per l'uso esclusivo di
          Say Help. Non acquisirai alcun diritto, titolo o interesse
          sull'Applicazione in virtù di questi Termini, salvo la licenza non
          esclusiva per utilizzare l'Applicazione in conformità con questi
          Termini.
        </Text>
        <Title order={4} py={10}>
          Feedback e risultati
        </Title>
        <Text size="sm" py={10}>
          Potresti essere invitato a fornire idee, suggerimenti o feedback
          relativi al tuo utilizzo dell'Applicazione (collettivamente, i
          "Feedback"), che Say Help può utilizzare per migliorare
          l'Applicazione. Inoltre, Say Help può tracciare e aggregare
          informazioni relative al tuo utilizzo dell'Applicazione
          (collettivamente, i "Risultati"). Accetti di non avanzare alcuna
          richiesta di compenso relativa all'utilizzo da parte di Say Help di
          Feedback o Risultati, né di rivendicare alcun diritto di proprietà su
          Feedback o Risultati.
        </Text>
        <Title order={4} py={10}>
          Esclusione di garanzie
        </Title>
        <Text size="sm" py={10}>
          PUR FACENDO IL POSSIBILE PER GARANTIRE CHE L'APPLICAZIONE FUNZIONI
          COME PREVISTO, SAY HELP NON GARANTISCE CHE L'APPLICAZIONE FUNZIONERÀ
          SEMPRE IN TUTTE LE CIRCOSTANZE. IN PARTICOLARE, L'APPLICAZIONE DIPENDE
          DAL FATTO CHE IL TUO DISPOSITIVO MOBILE ABBIA: (1) UN SEGNALE
          CELLULARE PER INVIARE UN MESSAGGIO DI TESTO; (2) INFORMAZIONI SULLA
          POSIZIONE GPS; E (3) UNA CONNESSIONE DATI. IN ASSENZA DI UNO QUALSIASI
          DI QUESTI TRE REQUISITI, L'APPLICAZIONE NON FUNZIONERÀ COME
          PROGETTATO. INOLTRE, POTREBBERO ESSERCI ALTRE CIRCOSTANZE CHE
          IMPEDISCONO ALL'APPLICAZIONE DI RICONOSCERE IL TUO COMANDO VOCALE. SAY
          HELP NON SI ASSUME ALCUNA RESPONSABILITÀ PER IL FUNZIONAMENTO DEL TUO
          DISPOSITIVO MOBILE, LA SUA CAPACITÀ DI LAVORARE CON L'APPLICAZIONE O
          LA CAPACITÀ DELL'APPLICAZIONE DI RICONOSCERE IL TUO COMANDO VOCALE IN
          UNA DATA CIRCOSTANZA. È TUA ESCLUSIVA RESPONSABILITÀ ASSICURARTI CHE
          IL TUO DISPOSITIVO MOBILE E LA SUA CONNESSIONE SIANO SEMPRE ADEGUATI.
        </Text>
        <Text size="sm" py={10}>
          NELLA MISURA CONSENTITA DALLA LEGGE APPLICABILE, L'APPLICAZIONE È
          FORNITA "COSÌ COM'È", SENZA ALCUNA GARANZIA DI ALCUN TIPO, ESPRESSA O
          IMPLICITA. SAY HELP NON GARANTISCE, DICHIARA O ASSICURA CHE L'USO
          DELL'APPLICAZIONE SARÀ ININTERRUMPUTO, PRIVO DI ERRORI O VIRUS, O CHE
          L'APPLICAZIONE SODDISFERÀ LE TUE ESIGENZE. SAY HELP DECLINA OGNI
          GARANZIA, ESPRESSA O IMPLICITA, INCLUSE, MA NON LIMITATE A, QUALSIASI
          GARANZIA DI TITOLO, NON VIOLAZIONE, COMMERCIABILITÀ, IDONEITÀ PER UNO
          SCOPO PARTICOLARE O QUALSIASI GARANZIA DERIVANTE DA PRATICHE
          COMMERCIALI O USI DEL COMMERCIO.
        </Text>
        <Title order={4} py={10}>
          Limitation di responsabilità
        </Title>
        <Text size="sm" py={10}>
          USTED RECONOCE Y ACEPTA QUE EL USO DE LA APLICACIÓN ES BAJO SU PROPIO
          RIESGO. NI SAY HELP, NI NINGUNO DE SUS MIEMBROS, GERENTES, EMPLEADOS,
          AFILIADOS, AGENTES, REPRESENTANTES, LICENCIANTES, SUCCESSORS, O
          CESSIONARIOS (COLLECTIVAMENTE, “SAY HELP ASSOCIADOS”) SARANNO
          RESPONSABILI NEI TUOI CONFRONTI PER QUALSIASI DANNO COMPENSATIVO,
          DIRETTO, INDIRETTO, INCIDENTALE, SPECIALE, ESEMPLARE, PUNITIVO O
          CONSEQUENZIALE, O SPESE LEGALI, O PER PERDITA DI DATI O DI PROFITTI
          DERIVANTI DA: (A) L'USO DELL'APPLICAZIONE; (B) L'IMPOSSIBILITÀ DI
          ACCEDERE O UTILIZZARE L'APPLICAZIONE; E/O (C) LA VIOLAZIONE DI QUESTI
          TERMINI DA PARTE DI SAY HELP.
        </Text>
        <Text size="sm" py={10}>
          LE PRECEDENTI ESCLUSIONI DI RESPONSABILITÀ SI APPLICANO ANCHE SE SAY
          HELP È STATA AVVISATA DELLA POSSIBILITÀ DI TALI DANNI O SE TALI DANNI
          ERANO PREVEDIBILI. IL TUO UNICO DIRITTO E RIMEDIO IN RELAZIONE A
          QUALSIASI CONTROVERSIA CON SAY HELP È INTERROMPERE L'USO
          DELL'APPLICAZIONE. POICHÉ ALCUNI STATI O GIURISDICIONI NON CONSENTONO
          L'ESCLUSIONE O LA LIMITAZIONE DI RESPONSABILITÀ PER DANNI
          CONSEQUENZIALI, INCIDENTALI O SPECIALI, IN TALI STATI E GIURISDICIONI
          LA RESPONSABILITÀ È LIMITATA NELLA MISURA MASSIMA CONSENTITA DALLA
          LEGGE.
        </Text>
        <Title order={4} py={10}>
          Indennizzo
        </Title>
        <Text size="sm" py={10}>
          Accetti di indennizzare, difendere e tenere indenne Say Help e gli
          Associati di Say Help da tutte le perdite, responsabilità, spese,
          danni, reclami, richieste e costi, incluse le ragionevoli spese legali
          e i costi giudiziari, relativi o derivanti da: (a) qualsiasi
          violazione di questi Termini da parte tua; e (b) reclami avanzati da
          terzi, come le forze dell'ordine, che derivano dal tuo utilizzo
          dell'Applicazione.
        </Text>
        <Title order={4} py={10}>
          Informativa sulla privacy
        </Title>
        <Text size="sm" py={10}>
          Say Help rispetta e si impegna a proteggere la tua privacy. Consulta
          l'Informativa sulla privacy di Say Help{' '}
          <a
            href="https://sayhelp.com/privacy/it"
            target="_blank"
            rel="noreferrer">
            Informativa sulla privacy
          </a>
          , che regola anche l'utilizzo dell'Applicazione, per comprendere le
          pratiche di Say Help.
        </Text>
        <Title order={4} py={10} align="left">
          Varie
        </Title>
        <Text size="sm" py={10}>
          Le leggi dello Stato del Wyoming regolano la validità, l'esecuzione,
          l'applicazione, l'interpretazione e qualsiasi altro aspetto di questi
          Termini, senza riguardo ai principi di conflitto di leggi. Le parti
          concordano di sottoporsi alla giurisdizione e competenza esclusiva dei
          tribunali della Contea di Johnson, Wyoming, per qualsiasi azione
          derivante da questi Termini. Say Help avrà diritto al rimborso di
          tutte le spese sostenute, incluse, a titolo esemplificativo, le spese
          legali, in relazione all'applicazione di questi Termini.
        </Text>
        <Text size="sm" py={10}>
          Riconosci e accetti che le disposizioni, le divulgazioni e le
          esclusioni di responsabilità stabilite in questi Termini sono eque e
          ragionevoli e il tuo accordo a rispettarli non è il risultato di
          frode, coercizione o influenza indebita esercitata su di te da
          qualsiasi persona o entità. Il mancato esercizio o applicazione da
          parte di Say Help di qualsiasi diritto o disposizione di questi
          Termini non costituirà una rinuncia a tale diritto o disposizione. Se
          una qualsiasi disposizione di questi Termini viene ritenuta non valida
          da un tribunale competente, le parti concordano comunque che il
          tribunale dovrebbe cercare di dare effetto alle intenzioni delle parti
          come riflesso nella disposizione, e le altre disposizioni dei Termini
          rimarranno in pieno vigore ed effetto.
        </Text>
        <Text size="sm" py={10}>
          Say Help avrà il diritto di cedere questi Termini e di concedere in
          sublicenza tutti i suoi diritti ai sensi di questi Termini. Questi
          Termini, inclusi i documenti a cui si fa riferimento nel presente
          documento e qualsiasi termine e condizione aggiuntivo pubblicato
          tramite l'Applicazione, rappresentano l'intero accordo tra te e Say
          Help in relazione all'Applicazione. Questi Termini sostituiscono tutti
          i precedenti accordi scritti o orali tra te e Say Help in relazione a
          tale materia. Fermo restando qualsiasi disposizione di questi Termini,
          Say Help ha a disposizione tutti i rimedi legali o di equità per far
          rispettare questi Termini.
        </Text>
        <Text size="sm" py={10}></Text>
      </Box>
    );

  if (language === 'de')
    return (
      <Box className={classes.container} {...otherProps}>
        <Text size="sm" py={10}>
          Bitte lesen Sie die folgenden Nutzungsbedingungen ("Bedingungen") sorgfältig durch. Diese Bedingungen regeln Ihre Nutzung der mobilen Anwendung von Say Help, LLC ("Say Help") (die "Anwendung"). Wenn Sie diesen Bedingungen nicht zustimmen, löschen Sie bitte unverzüglich die Anwendung und stellen Sie deren Nutzung ein.
        </Text>

        <Text size="sm" py={10}>
          Say Help behält sich das Recht vor, die Bedingungen, unter denen die Anwendung angeboten wird, nach eigenem Ermessen jederzeit und ohne Vorankündigung zu ändern. Alle Änderungen der Bedingungen treten ab dem Datum der Veröffentlichung in Kraft.
        </Text>
        <Title order={4} py={10}>
          Registrierung für die Anwendung
        </Title>
        <Text size="sm" py={10}>
          Die Anwendung nutzt aktuelle Technologie, um eine Textnachricht und/oder einen Notfallalarm an eine öffentliche Sicherheitsleitstelle (PSAP) zu senden, die Ihren aktuellen Standort, GPS und Profilinformationen angibt, falls Sie den Sprachbefehl HILFE HILFE HILFE oder einen anderen von Say Help identifizierten Sprachbefehl geben (der "Sprachbefehl"). Um auf die Anwendung zuzugreifen und sie zu nutzen, müssen Sie ein Benutzerkonto ("Ihr Konto") einrichten und diese Bedingungen befolgen. Durch die Einrichtung und Führung Ihres Kontos stimmen Sie zu, genaue Informationen über Ihre Identität, Ihre Kontaktinformationen und alle anderen von Say Help angeforderten Informationen bereitzustellen. Sie legen Ihr eigenes Passwort für den Zugang zum Service fest und sind allein und ausschließlich verantwortlich für alles, was durch die Nutzung Ihres Kontos geschieht.
        </Text>
        <Title order={4} py={10}>
          Nutzung der Anwendung
        </Title>
        <Text size="sm" py={10}>
          Die Anwendung darf nur für legale und angemessene Zwecke verwendet werden. Say Help behält sich das Recht vor, jederzeit und ohne Vorankündigung Änderungen an der Anwendung vorzunehmen. Ihr Zugang zur und Ihre Nutzung der Anwendung kann jederzeit ohne Vorankündigung aus beliebigen oder ohne Grund blockiert, ausgesetzt oder beendet werden. Obwohl die folgende Liste nicht vollständig ist, kann Ihr Zugang zur Anwendung von Say Help jederzeit wegen Verstoßes gegen die folgenden Regeln eingeschränkt oder widerrufen werden:
        </Text>
        <List
          withPadding
          size="sm"
          style={{
            listStylePosition: 'outside',
          }}>
          <List.Item py={10}>
            Sie müssen alle staatlichen, bundesstaatlichen und/oder internationalen Gesetze, Vorschriften, Richtlinien und/oder Lizenzen befolgen, die die Kommunikation bei der Nutzung der Anwendung regeln.
          </List.Item>
          <List.Item py={10}>
            Sie dürfen die Anwendung nicht unangemessen verwenden, z.B. um Notfalldienste anzufordern, wenn solche Dienste nicht erforderlich sind, oder um andere zu belästigen oder zu verfolgen.
          </List.Item>
          <List.Item py={10}>
            Sie dürfen die Anwendung oder die Nutzung der Anwendung durch andere Personen nicht durch Programme, Skripte, Befehle, Geräte, Software, Routinen oder anderweitig stören oder zu stören versuchen.
          </List.Item>
          <List.Item py={10}>
            Sie dürfen nicht versuchen, unbefugten Zugang zu einem Teil oder einer Funktion der Anwendung zu erlangen oder anderweitig zu versuchen, die Anwendung in einer Weise zu nutzen, die die Grenzen der Rechte überschreitet, die Say Help hierin gewährt hat.
          </List.Item>
          <List.Item py={10}>
            Sie dürfen die Anwendung (und/oder alle Algorithmen, die bei der Erstellung der Anwendung verwendet werden) nicht kopieren, dekompilieren und/oder zurückentwickeln und/oder abgeleitete Werke auf Basis der Anwendung erstellen.
          </List.Item>
          <List.Item py={10}>
            Sie dürfen die Anwendung nicht zum Zwecke der Entwicklung einer Anwendung verwenden, die in der Natur oder dem Zweck der Anwendung ähnlich ist.
          </List.Item>
          <List.Item py={10}>
            Sie dürfen sich nicht an Aktivitäten beteiligen, die nach alleinigem Ermessen von Say Help einen Missbrauch der Anwendung darstellen.
          </List.Item>
        </List>

        <Title order={4} py={10}>
          Lizenz
        </Title>
        <Text size="sm" py={10}>
          Say Help gewährt Ihnen eine begrenzte, nicht-exklusive, nicht-übertragbare Lizenz zum Zugriff auf und zur Nutzung der Anwendung. Jede unbefugte Nutzung der Anwendung beendet automatisch die Ihnen hierin gewährte Lizenz. Darüber hinaus behält sich Say Help das Recht vor, diese Lizenz jederzeit und aus beliebigen Gründen zu widerrufen. Alle Rechte an der Anwendung, die hierin nicht ausdrücklich gewährt werden, gelten als für die ausschließliche Nutzung durch Say Help vorbehalten. Sie werden durch diese Bedingungen keine Rechte, Titel oder Anteile an der Anwendung erwerben, außer der nicht-exklusiven Lizenz zur Nutzung der Anwendung in Übereinstimmung mit diesen Bedingungen.
        </Text>

        <Title order={4} py={10}>
          Feedback und Ergebnisse
        </Title>
        <Text size="sm" py={10}>
          Sie können gebeten werden, Ideen, Vorschläge oder Feedback bezüglich Ihrer Nutzung der Anwendung zu geben (zusammen das "Feedback"), das von Say Help zur Verbesserung der Anwendung verwendet werden kann. Darüber hinaus kann Say Help Informationen bezüglich Ihrer Nutzung der Anwendung verfolgen und aggregieren (zusammen die "Ergebnisse"). Sie stimmen zu, dass Sie keinen Anspruch auf Entschädigung bezüglich der Nutzung des Feedbacks oder der Ergebnisse durch Say Help haben werden, noch werden Sie Eigentumsrechte am Feedback oder den Ergebnissen beanspruchen.
        </Text>

        <Title order={4} py={10}>
          Gewährleistungsausschluss
        </Title>
        <Text size="sm" py={10}>
          OBWOHL SAY HELP SICH BEMÜHT, SICHERZUSTELLEN, DASS DIE ANWENDUNG WIE BEABSICHTIGT FUNKTIONIERT, GARANTIERT SAY HELP NICHT, DASS DIE ANWENDUNG IMMER UNTER ALLEN UMSTÄNDEN FUNKTIONIERT. INSBESONDERE IST DIE ANWENDUNG DAVON ABHÄNGIG, DASS IHR MOBILGERÄT FOLGENDES HAT: (1) EIN MOBILFUNKSIGNAL ZUM SENDEN EINER TEXTNACHRICHT; (2) GPS-STANDORTINFORMATIONEN UND (3) EINE DATENVERBINDUNG. OHNE EINES DIESER DREI KRITERIEN FUNKTIONIERT DIE ANWENDUNG NICHT WIE VORGESEHEN. DARÜBER HINAUS KÖNNTEN ANDERE UMSTÄNDE VORLIEGEN, DIE DAZU FÜHREN, DASS DIE ANWENDUNG IHREN SPRACHBEFEHL NICHT ERKENNT. SAY HELP ÜBERNIMMT KEINE VERANTWORTUNG DAFÜR, OB UND/ODER WIE IHR MOBILGERÄT FUNKTIONIERT, FÜR DIE FÄHIGKEIT IHRES MOBILGERÄTS, MIT DER ANWENDUNG ZU ARBEITEN, UND/ODER FÜR DIE FÄHIGKEIT DER ANWENDUNG, IHREN SPRACHBEFEHL UNTER GEGEBENEN UMSTÄNDEN ZU ERKENNEN. ES LIEGT AUSSCHLIESSLICH IN IHRER VERANTWORTUNG SICHERZUSTELLEN, DASS IHR MOBILGERÄT UND SEINE VERBINDUNG JEDERZEIT AUSREICHEND SIND.
        </Text>
        <Text size="sm" py={10}>
          SOWEIT NACH GELTENDEM RECHT ZULÄSSIG, WIRD DIE ANWENDUNG "WIE BESEHEN" BEREITGESTELLT, OHNE GEWÄHRLEISTUNG JEGLICHER ART, WEDER AUSDRÜCKLICH NOCH STILLSCHWEIGEND. SAY HELP GARANTIERT, ERKLÄRT ODER GEWÄHRLEISTET NICHT, DASS DIE NUTZUNG DER ANWENDUNG UNUNTERBROCHEN, FEHLERFREI ODER VIRENFREI SEIN WIRD, ODER DASS DIE ANWENDUNG IHRE ANFORDERUNGEN ERFÜLLT. SAY HELP LEHNT ALLE GEWÄHRLEISTUNGEN AB, AUSDRÜCKLICH ODER STILLSCHWEIGEND, EINSCHLIESSLICH, ABER NICHT BESCHRÄNKT AUF JEDE GEWÄHRLEISTUNG DES TITELS, DER NICHT-VERLETZUNG, DER MARKTGÄNGIGKEIT, DER EIGNUNG FÜR EINEN BESTIMMTEN ZWECK ODER JEDE GEWÄHRLEISTUNG, DIE AUS EINEM GESCHÄFTSVERLAUF, HANDELSBRAUCH ODER HANDELSPRAXIS ENTSTEHT.
        </Text>

        <Title order={4} py={10}>
          Haftungsbeschränkung
        </Title>
        <Text size="sm" py={10}>
          SIE ERKENNEN AN UND STIMMEN ZU, DASS IHRE NUTZUNG DER ANWENDUNG AUF EIGENES RISIKO ERFOLGT. WEDER SAY HELP NOCH EINER SEINER MITGLIEDER, MANAGER, ANGESTELLTEN, VERBUNDENEN UNTERNEHMEN, AGENTEN, VERTRETER, LIZENZGEBER, NACHFOLGER ODER ABTRETUNGSEMPFÄNGER (ZUSAMMEN "SAY HELP VERBUNDENE") HAFTEN IHNEN GEGENÜBER FÜR KOMPENSATORISCHE, DIREKTE, INDIREKTE, ZUFÄLLIGE, BESONDERE, BEISPIELHAFTE, STRAF- ODER FOLGESCHÄDEN ODER ANWALTSKOSTEN ODER FÜR DATENVERLUST ODER GEWINNVERLUST, DIE ENTSTEHEN AUS: (A) DER NUTZUNG DER ANWENDUNG; (B) DER UNFÄHIGKEIT, ZUGANG ZUR ANWENDUNG ZU ERHALTEN ODER SIE ZU NUTZEN; UND/ODER (C) SAY HELPS VERLETZUNG DIESER BEDINGUNGEN.
        </Text>
        <Text size="sm" py={10}>
          DIE VORSTEHENDEN HAFTUNGSAUSSCHLÜSSE GELTEN AUCH DANN, WENN SAY HELP ÜBER DIE MÖGLICHKEIT SOLCHER SCHÄDEN INFORMIERT WURDE ODER SOLCHE SCHÄDEN VORHERSEHBAR WAREN. IHR EINZIGES RECHT UND RECHTSMITTEL BEZÜGLICH JEDER STREITIGKEIT MIT SAY HELP IST, DIE NUTZUNG DER ANWENDUNG EINZUSTELLEN. DA EINIGE STAATEN ODER GERICHTSBARKEITEN DEN AUSSCHLUSS ODER DIE BESCHRÄNKUNG DER HAFTUNG FÜR FOLGE-, ZUFALLS- ODER BESONDERE SCHÄDEN NICHT ZULASSEN, IST DIE HAFTUNG IN SOLCHEN STAATEN UND GERICHTSBARKEITEN AUF DAS GESETZLICH ZULÄSSIGE HÖCHSTMASS BESCHRÄNKT.
        </Text>

        <Title order={4} py={10}>
          Entschädigung
        </Title>
        <Text size="sm" py={10}>
          Sie stimmen zu, Say Help und die Say Help Verbundenen von allen Verlusten, Verbindlichkeiten, Ausgaben, Schäden, Ansprüchen, Forderungen und Kosten, einschließlich angemessener Anwaltskosten und Gerichtskosten, zu entschädigen, zu verteidigen und schadlos zu halten, die sich beziehen auf oder entstehen aus: (a) jeder Verletzung dieser Bedingungen durch Sie; und (b) Ansprüchen von Dritten, wie Strafverfolgungsbehörden, die aus Ihrer Nutzung der Anwendung resultieren.
        </Text>

        <Title order={4} py={10}>
          Datenschutzrichtlinie
        </Title>
        <Text size="sm" py={10}>
          Say Help respektiert und verpflichtet sich zu Ihrem Datenschutz. Bitte überprüfen Sie Say Helps{' '}
          <a
            href="https://sayhelp.com/privacy/de"
            target="_blank"
            rel="noreferrer">
            Datenschutzrichtlinie
          </a>
          , die auch Ihre Nutzung der Anwendung regelt, um Say Helps Praktiken zu verstehen.
        </Text>

        <Title order={4} py={10} align="left">
          Verschiedenes
        </Title>
        <Text size="sm" py={10}>
          Die Gesetze des Staates Wyoming regeln die Gültigkeit, Leistung, Durchsetzung, Auslegung und jeden anderen Aspekt dieser Bedingungen, ohne Rücksicht auf Grundsätze der Gesetzeskonflikte. Die Parteien stimmen zu, sich der ausschließlichen Gerichtsbarkeit und Zuständigkeit der Gerichte von Johnson County, Wyoming, für jede Klage zu unterwerfen, die aus diesen Bedingungen entsteht. Say Help hat Anspruch auf Zahlung von Ihnen für alle Auslagen, einschließlich, aber nicht beschränkt auf Anwaltskosten, die Say Help im Zusammenhang mit der Durchsetzung dieser Bedingungen entstehen.
        </Text>
        <Text size="sm" py={10}>
          Sie erkennen an und stimmen zu, dass die in diesen Bedingungen dargelegten Bestimmungen, Offenlegungen und Haftungsausschlüsse fair und angemessen sind und Ihre Zustimmung, sie zu befolgen und an sie gebunden zu sein, nicht das Ergebnis von Betrug, Zwang oder unzulässiger Beeinflussung durch eine Person oder Entität ist. Das Versäumnis von Say Help, ein Recht oder eine Bestimmung dieser Bedingungen auszuüben oder durchzusetzen, stellt keinen Verzicht auf solches Recht oder solche Bestimmung dar. Wenn eine Bestimmung dieser Bedingungen von einem zuständigen Gericht als ungültig befunden wird, stimmen die Parteien dennoch zu, dass das Gericht sich bemühen sollte, den Absichten der Parteien, wie sie in der Bestimmung widergespiegelt werden, Wirkung zu verleihen, und die anderen Bestimmungen der Bedingungen bleiben in vollem Umfang wirksam.
        </Text>

        <Text size="sm" py={10}>
          Say Help hat das Recht, diese Bedingungen abzutreten und alle seine Rechte unter diesen Bedingungen zu unterlizenzieren. Diese Bedingungen, einschließlich aller hierin referenzierten Dokumente und aller zusätzlichen Bedingungen, die über die Anwendung veröffentlicht werden, stellen das vollständige Verständnis zwischen Ihnen und Say Help bezüglich der Anwendung dar. Diese Bedingungen ersetzen alle vorherigen schriftlichen oder mündlichen Vereinbarungen zwischen Ihnen und Say Help bezüglich dieses Gegenstands. Ungeachtet jeder Bestimmung dieser Bedingungen stehen Say Help alle Rechtsmittel zur Verfügung, um diese Bedingungen durchzusetzen.
        </Text>
        <Text size="sm" py={10}></Text>
      </Box>
    );

  if (language === 'fr')
    return (
      <Box className={classes.container} {...otherProps}>
        <Text size="sm" py={10}>
          Veuillez lire attentivement les Conditions d'utilisation suivantes ("Conditions"). Ces Conditions régissent votre utilisation de l'application mobile Say Help, LLC ("Say Help") (l'"Application"). Si vous n'acceptez pas d'être lié par ces Conditions, veuillez supprimer immédiatement l'Application et cesser toute utilisation.
        </Text>

        <Text size="sm" py={10}>
          Say Help se réserve le droit de modifier les Conditions sous lesquelles l'Application est offerte à sa seule et absolue discrétion à tout moment et sans préavis. Toutes les modifications des Conditions sont effectives à compter de la date de publication.
        </Text>
        <Title order={4} py={10}>
          Inscription à l'Application
        </Title>
        <Text size="sm" py={10}>
          L'Application utilise une technologie actuelle pour envoyer un message texte et/ou une alerte d'urgence à un Centre de Réponse de Sécurité Publique (PSAP) indiquant votre localisation actuelle, GPS et informations de profil dans le cas où vous donneriez la commande vocale AIDE AIDE AIDE ou une autre commande vocale identifiée par Say Help (la "Commande Vocale"). Pour accéder et utiliser l'Application, vous devez créer un compte utilisateur ("Votre Compte") et respecter ces Conditions. En créant et maintenant Votre Compte, vous acceptez de fournir des informations exactes concernant votre identité, vos informations de contact et toute autre information demandée par Say Help. Vous définirez votre propre mot de passe pour accéder au Service et serez seul et strictement responsable de tout ce qui se produit par l'utilisation de Votre Compte.
        </Text>
        <Title order={4} py={10}>
          Utilisation de l'Application
        </Title>
        <Text size="sm" py={10}>
          L'Application ne peut être utilisée que pour des usages légaux et appropriés. Say Help se réserve le droit d'apporter des modifications à l'Application à tout moment et sans préavis. Votre accès et utilisation de l'Application peuvent être bloqués, suspendus ou terminés sans préavis à tout moment pour toute raison ou sans raison du tout. Bien que la liste suivante ne soit pas exhaustive, votre accès à l'Application peut être limité ou révoqué par Say Help à tout moment pour toute violation des règles suivantes :
        </Text>
        <List
          withPadding
          size="sm"
          style={{
            listStylePosition: 'outside',
          }}>
          <List.Item py={10}>
            Vous devez vous conformer à toutes les lois, règles, politiques et/ou licences d'État, fédérales et/ou internationales régissant les communications lors de l'utilisation de l'Application.
          </List.Item>
          <List.Item py={10}>
            Vous ne pouvez pas utiliser l'Application de manière inappropriée, comme pour demander des services d'urgence lorsque de tels services ne sont pas requis, ou pour harceler ou persécuter d'autres personnes.
          </List.Item>
          <List.Item py={10}>
            Vous ne pouvez pas interférer ou tenter d'interférer avec l'Application ou l'utilisation de l'Application par une autre personne en utilisant tout programme, script, commande, dispositif, logiciel, routine ou autrement.
          </List.Item>
          <List.Item py={10}>
            Vous ne pouvez pas tenter d'obtenir un accès non autorisé à toute partie ou fonctionnalité de l'Application, ou autrement tenter d'utiliser l'Application d'une manière qui dépasse les limites des droits que Say Help a accordés dans ce document.
          </List.Item>
          <List.Item py={10}>
            Vous ne pouvez pas copier, décompiler et/ou faire de l'ingénierie inverse de l'Application (et/ou tout algorithme utilisé pour créer l'Application) et/ou créer des œuvres dérivées basées sur l'Application.
          </List.Item>
          <List.Item py={10}>
            Vous ne pouvez pas utiliser l'Application dans le but de développer une application similaire en nature ou en objectif à l'Application.
          </List.Item>
          <List.Item py={10}>
            Vous ne pouvez pas vous engager dans des activités qui constituent, à la seule discrétion de Say Help, un abus de l'Application.
          </List.Item>
        </List>

        <Title order={4} py={10}>
          Licence
        </Title>
        <Text size="sm" py={10}>
          Say Help vous accorde une licence limitée, non exclusive et non transférable pour accéder et utiliser l'Application. Toute utilisation non autorisée de l'Application résiliera automatiquement la licence qui vous est accordée dans ce document. De plus, Say Help se réserve le droit de révoquer cette licence à tout moment et pour toute raison. Tous les droits dans l'Application non expressément accordés dans ce document seront considérés comme réservés pour l'usage exclusif de Say Help. Vous n'acquerrez aucun droit, titre ou intérêt dans l'Application en raison de ces Conditions, à l'exception de la licence non exclusive d'utiliser l'Application conformément à ces Conditions.
        </Text>

        <Title order={4} py={10}>
          Commentaires et Résultats
        </Title>
        <Text size="sm" py={10}>
          Il peut vous être demandé de fournir des idées, suggestions ou commentaires concernant votre utilisation de l'Application (collectivement, les "Commentaires"), qui peuvent être utilisés par Say Help pour améliorer l'Application. De plus, Say Help peut suivre et agréger des informations concernant votre utilisation de l'Application (collectivement, les "Résultats"). Vous acceptez que vous n'aurez aucune réclamation de compensation concernant l'utilisation par Say Help des Commentaires ou Résultats, ni ne revendiquerez aucun droit de propriété sur les Commentaires ou Résultats.
        </Text>

        <Title order={4} py={10}>
          Déni de Garanties
        </Title>
        <Text size="sm" py={10}>
          BIEN QUE SAY HELP S'EFFORCE DE S'ASSURER QUE L'APPLICATION FONCTIONNE COMME PRÉVU, SAY HELP NE GARANTIT PAS QUE L'APPLICATION FONCTIONNERA TOUJOURS DANS TOUTES LES CIRCONSTANCES. EN PARTICULIER, L'APPLICATION DÉPEND DE VOTRE APPAREIL MOBILE AYANT : (1) UN SIGNAL CELLULAIRE POUR ENVOYER UN MESSAGE TEXTE ; (2) DES INFORMATIONS DE LOCALISATION GPS ET (3) UNE CONNEXION DE DONNÉES. EN L'ABSENCE DE L'UN DE CES TROIS CRITÈRES, L'APPLICATION NE FONCTIONNERA PAS COMME CONÇUE. DE PLUS, IL POURRAIT Y AVOIR D'AUTRES CIRCONSTANCES PRÉSENTES QUI CAUSENT À L'APPLICATION DE NE PAS RECONNAÎTRE VOTRE COMMANDE VOCALE. SAY HELP N'ASSUME AUCUNE RESPONSABILITÉ POUR SI ET/OU COMMENT VOTRE APPAREIL MOBILE FONCTIONNE, LA CAPACITÉ DE VOTRE APPAREIL MOBILE À TRAVAILLER AVEC L'APPLICATION, ET/OU LA CAPACITÉ DE L'APPLICATION À RECONNAÎTRE VOTRE COMMANDE VOCALE DANS UNE CIRCONSTANCE DONNÉE. IL EST UNIQUEMENT DE VOTRE RESPONSABILITÉ DE S'ASSURER QUE VOTRE APPAREIL MOBILE ET SA CONNEXION SONT SUFFISANTS EN TOUT TEMPS.
        </Text>
        <Text size="sm" py={10}>
          DANS LA MESURE PERMISE PAR LA LOI APPLICABLE, L'APPLICATION EST FOURNIE "EN L'ÉTAT", SANS GARANTIE D'AUCUNE SORTE, EXPRESSE OU IMPLICITE. SAY HELP NE GARANTIT PAS, NE REPRÉSENTE PAS OU NE WARRANT PAS QUE L'UTILISATION DE L'APPLICATION SERA ININTERROMPUE, SANS ERREUR OU SANS VIRUS, OU QUE L'APPLICATION RÉPONDRA À VOS EXIGENCES. SAY HELP DÉNIE TOUTES LES GARANTIES, EXPRESSES OU IMPLICITES, Y COMPRIS, MAIS SANS S'Y LIMITER, TOUTE GARANTIE DE TITRE, DE NON-VIOLATION, DE COMMERCIALISATION, D'ADÉQUATION À UN BUT PARTICULIER, OU TOUTE GARANTIE DÉCOULANT D'UN COURS DE TRANSACTION, D'USAGE COMMERCIAL OU DE PRATIQUE COMMERCIALE.
        </Text>

        <Title order={4} py={10}>
          Limitation de Responsabilité
        </Title>
        <Text size="sm" py={10}>
          VOUS RECONNAISSEZ ET ACCEPTEZ QUE VOTRE UTILISATION DE L'APPLICATION EST À VOS PROPRES RISQUES. NI SAY HELP, NI AUCUN DE SES MEMBRES, GESTIONNAIRES, EMPLOYÉS, AFFILIÉS, AGENTS, REPRÉSENTANTS, CONCÉDANTS, SUCCESSEURS OU CESSIONNAIRES (COLLECTIVEMENT, "ASSOCIÉS SAY HELP") NE SERONT RESPONSABLES ENVERS VOUS POUR TOUS DOMMAGES COMPENSATOIRES, DIRECTS, INDIRECTS, ACCESSOIRES, SPÉCIAUX, EXEMPLAIRES, PUNITIFS OU CONSÉCUTIFS, OU HONORAIRES D'AVOCATS, OU POUR PERTE DE DONNÉES OU PERTE DE PROFIT, DÉCOULANT DE : (A) L'UTILISATION DE L'APPLICATION ; (B) L'INCAPACITÉ D'ACCÉDER OU D'UTILISER L'APPLICATION ; ET/OU (C) LA VIOLATION DE CES CONDITIONS PAR SAY HELP.
        </Text>
        <Text size="sm" py={10}>
          LES EXCLUSIONS DE RESPONSABILITÉ PRÉCÉDENTES S'APPLIQUERONT MÊME SI SAY HELP A ÉTÉ AVISÉ DE LA POSSIBILITÉ DE TELS DOMMAGES OU SI DE TELS DOMMAGES ÉTAIENT PRÉVISIBLES. VOTRE SEUL DROIT ET RECOURS CONCERNANT TOUT DIFFÉREND AVEC SAY HELP EST DE CESSER D'UTILISER L'APPLICATION. PARCE QUE CERTAINS ÉTATS OU JURIDICTIONS NE PERMETTENT PAS L'EXCLUSION OU LA LIMITATION DE RESPONSABILITÉ POUR LES DOMMAGES CONSÉCUTIFS, ACCESSOIRES OU SPÉCIAUX, DANS DE TELS ÉTATS ET JURIDICTIONS LA RESPONSABILITÉ EST LIMITÉE DANS LA PLUS GRANDE MESURE PERMISE PAR LA LOI.
        </Text>

        <Title order={4} py={10}>
          Indemnisation
        </Title>
        <Text size="sm" py={10}>
          Vous acceptez d'indemniser, de défendre et de tenir indemnes Say Help et les Associés Say Help de toutes les pertes, responsabilités, dépenses, dommages, réclamations, demandes et coûts, y compris les honoraires d'avocats raisonnables et les coûts de justice, se rapportant à ou découlant de : (a) toute violation de ces Conditions par vous ; et (b) réclamations affirmées par des tiers, tels que l'application de la loi, qui résultent de votre utilisation de l'Application.
        </Text>

        <Title order={4} py={10}>
          Politique de Confidentialité
        </Title>
        <Text size="sm" py={10}>
          Say Help respecte et s'engage envers votre confidentialité. Veuillez consulter la{' '}
          <a
            href="https://sayhelp.com/privacy/fr"
            target="_blank"
            rel="noreferrer">
            Politique de Confidentialité
          </a>
          {' '}de Say Help, qui gouverne également votre utilisation de l'Application, pour comprendre les pratiques de Say Help.
        </Text>

        <Title order={4} py={10} align="left">
          Divers
        </Title>
        <Text size="sm" py={10}>
          Les lois de l'État du Wyoming régiront la validité, l'exécution, l'application, l'interprétation et tout autre aspect de ces Conditions, sans égard aux principes de conflits de lois. Les parties acceptent de se soumettre à la juridiction et au lieu exclusifs des tribunaux du Comté de Johnson, Wyoming, pour toute action découlant de ces Conditions. Say Help aura droit au paiement de votre part pour tous les coûts directs, y compris, sans limitation, les honoraires d'avocats, encourus par Say Help en relation avec l'application de ces Conditions.
        </Text>
        <Text size="sm" py={10}>
          Vous reconnaissez et acceptez que les dispositions, divulgations et dénis de responsabilité énoncés dans ces Conditions sont justes et raisonnables et votre accord de les suivre et d'être lié par eux n'est pas le résultat de fraude, de contrainte ou d'influence indue exercée sur vous par toute personne ou entité. L'échec de Say Help à exercer ou faire respecter tout droit ou disposition de ces Conditions ne constituera pas une renonciation à tel droit ou disposition. Si une disposition de ces Conditions est trouvée invalide par un tribunal de juridiction compétente, les parties acceptent néanmoins que le tribunal devrait s'efforcer de donner effet aux intentions des parties comme reflétées dans la disposition, et les autres dispositions des Conditions resteront en pleine force et effet.
        </Text>

        <Text size="sm" py={10}>
          Say Help aura le droit de céder ces Conditions et de sous-licencier tous ses droits sous ces Conditions. Ces Conditions, y compris tous les documents référencés dans ce document et tous les termes et conditions supplémentaires publiés via l'Application, représentent l'entente complète entre vous et Say Help concernant l'Application. Ces Conditions remplacent tous les accords écrits ou oraux précédents entre vous et Say Help concernant ce sujet. Nonobstant toute disposition de ces Conditions, Say Help dispose de tous les recours légaux ou équitables pour faire respecter ces Conditions.
        </Text>
        <Text size="sm" py={10}></Text>
      </Box>
    );

  if (language === 'ar')
    return (
      <Box className={classes.container} {...otherProps}>
        <Text size="sm" py={10}>
          يرجى قراءة شروط الاستخدام التالية ("الشروط") بعناية. ستحكم هذه الشروط استخدامك لتطبيق Say Help, LLC ("Say Help") للهاتف المحمول ("التطبيق"). إذا كنت لا توافق على الالتزام بهذه الشروط، يرجى حذف التطبيق فوراً ووقف جميع الاستخدامات.
        </Text>

        <Text size="sm" py={10}>
          تحتفظ Say Help بالحق في تغيير الشروط التي يتم تقديم التطبيق بموجبها وفقاً لتقديرها الخاص والمطلق في أي وقت ودون إشعار. جميع التغييرات على الشروط سارية المفعول من تاريخ النشر.
        </Text>
        <Title order={4} py={10}>
          التسجيل للتطبيق
        </Title>
        <Text size="sm" py={10}>
          يستخدم التطبيق التكنولوجيا الحالية لإرسال رسالة نصية و/أو تنبيه طوارئ إلى نقطة الاستجابة للسلامة العامة (PSAP) تشير إلى موقعك الحالي ونظام تحديد المواقع العالمي (GPS) ومعلومات الملف الشخصي في حالة إعطاء أمر صوتي "مساعدة مساعدة مساعدة" أو أمر صوتي آخر محدد من قبل Say Help ("الأمر الصوتي"). للوصول إلى التطبيق واستخدامه، يجب عليك إنشاء حساب مستخدم ("حسابك") والالتزام بهذه الشروط. من خلال إنشاء حسابك والمحافظة عليه، فإنك توافق على تقديم معلومات دقيقة حول هويتك ومعلومات الاتصال الخاصة بك وأي معلومات أخرى مطلوبة من قبل Say Help. ستضع كلمة المرور الخاصة بك للوصول إلى الخدمة وتكون مسؤولاً وحدك ومسؤولية صارمة عن كل ما يحدث من خلال استخدام حسابك.
        </Text>
        <Title order={4} py={10}>
          استخدام التطبيق
        </Title>
        <Text size="sm" py={10}>
          يمكن استخدام التطبيق فقط للاستخدامات القانونية والمناسبة. تحتفظ Say Help بالحق في إجراء تغييرات على التطبيق في أي وقت ودون إشعار. يمكن حظر وصولك إلى التطبيق واستخدامه أو تعليقه أو إنهاؤه دون إشعار مسبق في أي وقت لأي سبب أو بدون سبب على الإطلاق. على الرغم من أن القائمة التالية ليست شاملة، إلا أن وصولك إلى التطبيق قد يكون محدوداً أو ملغياً من قبل Say Help في أي وقت لأي انتهاك للقواعد التالية:
        </Text>
        <List
          withPadding
          size="sm"
          style={{
            listStylePosition: 'outside',
          }}>
          <List.Item py={10}>
            يجب عليك الامتثال لجميع قوانين الولاية والفيدرالية و/أو الدولية والقواعد والسياسات و/أو التراخيص التي تحكم الاتصالات أثناء استخدام التطبيق.
          </List.Item>
          <List.Item py={10}>
            لا يجوز لك استخدام التطبيق بشكل غير مناسب، مثل طلب خدمات الطوارئ عندما لا تكون هذه الخدمات مطلوبة، أو لمضايقة الآخرين أو إزعاجهم.
          </List.Item>
          <List.Item py={10}>
            لا يجوز لك التدخل أو محاولة التدخل في التطبيق أو استخدام شخص آخر للتطبيق من خلال استخدام أي برنامج أو نص أو أمر أو جهاز أو برنامج أو روتين أو غير ذلك.
          </List.Item>
          <List.Item py={10}>
            لا يجوز لك محاولة الحصول على وصول غير مصرح به إلى أي جزء أو ميزة من التطبيق، أو محاولة استخدام التطبيق بطريقة تتجاوز حدود الحقوق التي منحتها Say Help هنا.
          </List.Item>
          <List.Item py={10}>
            لا يجوز لك نسخ أو إلغاء تجميع و/أو الهندسة العكسية للتطبيق (و/أو أي خوارزميات مستخدمة في إنشاء التطبيق) و/أو إنشاء أعمال مشتقة بناءً على التطبيق.
          </List.Item>
          <List.Item py={10}>
            لا يجوز لك استخدام التطبيق لغرض تطوير تطبيق مماثل في الطبيعة أو الغرض للتطبيق.
          </List.Item>
          <List.Item py={10}>
            لا يجوز لك الانخراط في أي أنشطة تشكل، حسب تقدير Say Help الوحيد، إساءة استخدام للتطبيق.
          </List.Item>
        </List>

        <Title order={4} py={10}>
          الترخيص
        </Title>
        <Text size="sm" py={10}>
          تمنحك Say Help ترخيصاً محدوداً وغير حصري وغير قابل للتحويل للوصول إلى التطبيق واستخدامه. أي استخدام غير مصرح به للتطبيق سينهي تلقائياً الترخيص الممنوح لك هنا. علاوة على ذلك، تحتفظ Say Help بالحق في إلغاء هذا الترخيص في أي وقت ولأي سبب. جميع الحقوق في التطبيق التي لم يتم منحها صراحة هنا تُعتبر محفوظة للاستخدام الحصري من قبل Say Help. لن تكتسب أي حق أو ملكية أو مصلحة في التطبيق بسبب هذه الشروط، باستثناء الترخيص غير الحصري لاستخدام التطبيق وفقاً لهذه الشروط.
        </Text>

        <Title order={4} py={10}>
          الملاحظات والنتائج
        </Title>
        <Text size="sm" py={10}>
          قد يُطلب منك تقديم أفكار أو اقتراحات أو ملاحظات تتعلق باستخدامك للتطبيق (مجتمعة، "الملاحظات")، والتي قد تستخدمها Say Help لتحسين التطبيق. بالإضافة إلى ذلك، قد تتتبع Say Help وتجمع المعلومات المتعلقة باستخدامك للتطبيق (مجتمعة، "النتائج"). أنت توافق على أنه لن يكون لديك أي مطالبة بتعويض يتعلق باستخدام Say Help لأي من الملاحظات أو النتائج، ولن تدعي أي حقوق ملكية في الملاحظات أو النتائج.
        </Text>

        <Title order={4} py={10}>
          إخلاء المسؤولية عن الضمانات
        </Title>
        <Text size="sm" py={10}>
          بينما تسعى SAY HELP لضمان أن التطبيق سيعمل كما هو مقصود، لا تضمن SAY HELP أن التطبيق سيعمل دائماً في جميع الظروف. على وجه الخصوص، يعتمد التطبيق على وجود الأمور التالية في جهازك المحمول: (1) إشارة خلوية لإرسال رسالة نصية؛ (2) معلومات موقع GPS، و (3) اتصال بيانات. في غياب أي من هذه المعايير الثلاثة، لن يعمل التطبيق كما هو مصمم. علاوة على ذلك، قد تكون هناك ظروف أخرى تتسبب في عدم تعرف التطبيق على أمرك الصوتي. لا تتحمل SAY HELP أي مسؤولية عن كيفية عمل جهازك المحمول، أو قدرة جهازك المحمول على العمل مع التطبيق، و/أو قدرة التطبيق على التعرف على أمرك الصوتي في ظرف معين. مسؤوليتك وحدك هي ضمان أن جهازك المحمول واتصاله كافيان في جميع الأوقات.
        </Text>
        <Text size="sm" py={10}>
          إلى الحد المسموح به بموجب القانون المعمول به، يتم توفير التطبيق "كما هو"، دون ضمان من أي نوع، سواء كان صريحاً أو ضمنياً. لا تضمن SAY HELP أو تمثل أو تؤكد أن استخدام التطبيق سيكون دون انقطاع أو خالياً من الأخطاء أو الفيروسات، أو أن التطبيق سيلبي متطلباتك. تخلي SAY HELP مسؤوليتها عن جميع الضمانات، الصريحة أو الضمنية، بما في ذلك، على سبيل المثال لا الحصر، أي ضمان للملكية أو عدم الانتهاك أو القابلية للتسويق أو الملاءمة لغرض معين، أو أي ضمان ناشئ عن سير التعامل أو الاستخدام التجاري أو الممارسة التجارية.
        </Text>

        <Title order={4} py={10}>
          تحديد المسؤولية
        </Title>
        <Text size="sm" py={10}>
          أنت تقر وتوافق على أن استخدامك للتطبيق هو على مسؤوليتك الخاصة. لا تكون SAY HELP، ولا أي من أعضائها أو مديريها أو موظفيها أو الشركات التابعة لها أو وكلائها أو ممثليها أو مرخصيها أو خلفائها أو المتنازل لهم (مجتمعين، "شركاء SAY HELP") مسؤولين تجاهك عن أي أضرار تعويضية أو مباشرة أو غير مباشرة أو عرضية أو خاصة أو تمثيلية أو عقابية أو تبعية، أو أتعاب المحامين، أو فقدان البيانات أو فقدان الربح، الناشئة عن: (أ) استخدام التطبيق؛ (ب) عدم القدرة على الوصول إلى التطبيق أو استخدامه؛ و/أو (ج) انتهاك SAY HELP لهذه الشروط.
        </Text>
        <Text size="sm" py={10}>
          الاستبعادات السابقة من المسؤولية ستكون قابلة للتطبيق حتى لو تم تحذير SAY HELP من إمكانية حدوث مثل هذه الأضرار أو كانت مثل هذه الأضرار متوقعة. حقك الوحيد وسبيل الانتصاف فيما يتعلق بأي نزاع مع SAY HELP هو التوقف عن استخدام التطبيق. لأن بعض الولايات أو السلطات القضائية لا تسمح بالاستبعاد أو التحديد من المسؤولية عن الأضرار التبعية أو العرضية أو الخاصة، في هذه الولايات والسلطات القضائية تكون المسؤولية محدودة إلى أقصى حد يسمح به القانون.
        </Text>

        <Title order={4} py={10}>
          التعويض
        </Title>
        <Text size="sm" py={10}>
          أنت توافق على تعويض والدفاع عن وحماية SAY HELP وشركاء SAY HELP من وضد جميع الخسائر والالتزامات والنفقات والأضرار والمطالبات والطلبات والتكاليف، بما في ذلك أتعاب المحامين المعقولة وتكاليف المحكمة، المتعلقة بأو الناشئة عن: (أ) أي انتهاك لهذه الشروط من قبلك؛ و (ب) المطالبات المؤكدة من قبل أطراف ثالثة، مثل تطبيق القانون، التي تنتج عن استخدامك للتطبيق.
        </Text>

        <Title order={4} py={10}>
          سياسة الخصوصية
        </Title>
        <Text size="sm" py={10}>
          تحترم SAY HELP وتلتزم بخصوصيتك. يرجى مراجعة{' '}
          <a
            href="https://sayhelp.com/privacy/ar"
            target="_blank"
            rel="noreferrer">
            سياسة الخصوصية
          </a>
          {' '}الخاصة بـ SAY HELP، والتي تحكم أيضاً استخدامك للتطبيق، لفهم ممارسات SAY HELP.
        </Text>

        <Title order={4} py={10} align="left">
          متنوعة
        </Title>
        <Text size="sm" py={10}>
          تحكم قوانين ولاية وايومنغ صحة وأداء وإنفاذ وتفسير وأي جانب آخر من هذه الشروط، دون اعتبار لمبادئ تضارب القوانين تحتها. توافق الأطراف على الخضوع للاختصاص القضائي والمكان الحصري لمحاكم مقاطعة جونسون، وايومنغ لأي دعوى تنشأ عن هذه الشروط. ستكون SAY HELP مؤهلة للحصول على دفع منك لأي وجميع التكاليف النقدية، بما في ذلك، دون تحديد، أتعاب المحامين، المتكبدة من قبل SAY HELP فيما يتعلق بإنفاذ هذه الشروط.
        </Text>
        <Text size="sm" py={10}>
          أنت تقر وتوافق على أن الأحكام والإفصاحات وإخلاء المسؤولية المنصوص عليها في هذه الشروط عادلة ومعقولة وأن اتفاقك على اتباعها والالتزام بها ليس نتيجة الاحتيال أو الإكراه أو التأثير غير المبرر الذي تمارسه عليك أي شخص أو كيان. عدم ممارسة أو إنفاذ SAY HELP لأي حق أو حكم من هذه الشروط لن يشكل تنازلاً عن مثل هذا الحق أو الحكم. إذا وُجد أن أي حكم من هذه الشروط غير صالح من قبل محكمة مختصة، توافق الأطراف مع ذلك على أن المحكمة يجب أن تسعى لإعطاء تأثير لنوايا الأطراف كما هو منعكس في الحكم، وتبقى الأحكام الأخرى للشروط سارية المفعول بالكامل.
        </Text>

        <Text size="sm" py={10}>
          ستكون لـ SAY HELP الحق في تعيين هذه الشروط وترخيص أي وجميع حقوقها تحت هذه الشروط. هذه الشروط، بما في ذلك أي وثائق مرجعية هنا وأي شروط وأحكام إضافية كما هو منشور عبر التطبيق، تمثل الفهم الكامل بينك وبين SAY HELP فيما يتعلق بالتطبيق. هذه الشروط تحل محل جميع الاتفاقيات المكتوبة أو الشفهية السابقة بينك وبين SAY HELP فيما يتعلق بهذا الموضوع. رغم أي حكم من هذه الشروط، تتوفر لـ SAY HELP جميع سبل الانتصاف في القانون أو العدالة لإنفاذ هذه الشروط.
        </Text>
        <Text size="sm" py={10}></Text>
      </Box>
    );

  if (language === 'en' || 1)
    return (
      <Box className={classes.container} {...otherProps}>
        <Text size="sm" py={10}>
          Please read the following Terms of Use (“Terms”) carefully. These
          Terms will govern your use of Say Help, LLC (“Say Help”) mobile
          application (the “Application”). If you do not agree to be bound by
          these Terms, please promptly delete and cease all use of the
          Application.
        </Text>

        <Text size="sm" py={10}>
          Say Help reserves the right to change the Terms under which the
          Application is offered in its sole and absolute discretion at any time
          without notice. All changes to the Terms are effective from the date
          posted.
        </Text>
        <Title order={4} py={10}>
          Registration for the Application
        </Title>
        <Text size="sm" py={10}>
          The Application uses current technology to send a text message and/or
          an emergency alert to a Public Safety Answering Point (PSAP)
          indicating your current location, GPS, and profile information in the
          event that you give the HELP HELP HELP or other voice command
          identified by Say Help (the “Voice Command”). In order to access and
          use the Application, you must set up a user account (“Your Account”)
          and abide by these Terms. In setting up and maintaining Your Account,
          you agree to provide accurate information regarding your identity,
          your contact information, and any other information requested by Say
          Help. You will set your own password for accessing the Service and
          shall be solely and strictly liable for everything that occurs through
          the use of Your Account.
        </Text>
        <Title order={4} py={10}>
          Use of the Application
        </Title>
        <Text size="sm" py={10}>
          The Application may only be used for legal and appropriate uses. Say
          Help reserves the right to make changes to the Application at any time
          and without notice. Your access to and use of the Application may be
          blocked, suspended, or terminated without prior notice at any time for
          any reason or no reason at all. Although the following list is not
          exhaustive, your access to the Application may be limited or revoked
          by Say Help at any time for any violation of the following rules:
        </Text>
        <List
          withPadding
          size="sm"
          style={{
            listStylePosition: 'outside',
          }}>
          <List.Item py={10}>
            You must comply with all state, federal, and/or international laws,
            rules, policies and/or licenses governing communications while using
            the Application.
          </List.Item>
          <List.Item py={10}>
            You may not use the Application inappropriately, such as to request
            emergency services when such services are not required, or to swat
            or harass others.
          </List.Item>
          <List.Item py={10}>
            You may not interfere or attempt to interfere with the Application
            or another person’s use of the Application by use of any program,
            script, command, device, software, routine, or otherwise.
          </List.Item>
          <List.Item py={10}>
            You may not attempt to gain unauthorized access to any portion or
            feature of the Application, or otherwise attempt to use the
            Application in a manner that exceeds the limits of the rights that
            Say Help has granted herein.
          </List.Item>
          <List.Item py={10}>
             You may not copy, decompile, and/or reverse-engineer the
            Application (and/or any algorithms used in creating the Application)
            and/or create derivative works based upon the Application.
          </List.Item>
          <List.Item py={10}>
            You may not use the Application for the purpose of developing an
            application that is similar in nature or purpose to the Application.
          </List.Item>
          <List.Item py={10}>
            You may not engage in any activities that constitutes, in Say Help’s
            sole discretion, an abuse of the Application.
          </List.Item>
        </List>

        <Title order={4} py={10}>
          License
        </Title>
        <Text size="sm" py={10}>
          Say Help grants you a limited, non-exclusive, non-transferable license
          to access and use the Application. Any unauthorized use of the
          Application shall automatically terminate the license granted to you
          herein. Further, Say Help reserves the right to revoke this license at
          any time and for any reason. All rights in the Application not
          expressly granted herein shall be deemed as reserved for the exclusive
          use by Say Help. You will not acquire any right, title or interest in
          or to the Application by reason of these Terms, except for the
          non-exclusive license to use the Application in accordance with these
          Terms.
        </Text>

        <Title order={4} py={10}>
          Feedback and Results
        </Title>
        <Text size="sm" py={10}>
          You may be asked to provide ideas, suggestions, or feedback relating
          to your use of the Application (collectively, the “Feedback”), which
          may be used by Say Help to improve the Application. In addition, Say
          Help may track and aggregate information relating to your use of the
          Application (collectively, the “Results”). You agree that you shall
          not have any claim to compensation relating to Say Help’s use of any
          the Feedback or Results, nor shall you claim any ownership rights in
          the Feedback or Results.
        </Text>

        <Title order={4} py={10}>
          Disclaimer of Warranties
        </Title>
        <Text size="sm" py={10}>
          WHILE SAY HELP ENDEAVORS TO ENSURE THAT THE APPLICATION WILL WORK AS
          INTENDED, SAY HELP DOES NOT GUARANTEE THAT THE APPLICATION WILL ALWAYS
          FUNCTION IN ALL CIRCUMSTANCES. IN PARTICULAR, THE APPLICATION IS
          DEPENDENT ON YOUR MOBILE DEVICE HAVING: (1) A CELLULAR SIGNAL TO SEND
          A TEXT MESSAGE; (2) GPS LOCATION INFORMATION, AND (3) A DATA
          CONNECTION. ABSENT ANY ONE OF THESE THREE CRITERIA, THE APPLICATION
          WILL NOT FUNCTION AS DESIGNED. MOREOVER, THERE COULD BE OTHER
          CIRCUMSTANCES PRESENT THAT CAUSE THE APPLICATION TO NOT RECOGNIZE YOUR
          VOICE COMMAND. SAY HELP ASSUMES NO RESPONSIBILITY FOR IF AND/OR HOW
          YOUR MOBILE DEVICE IS FUNCTIONING, YOUR MOBILE DEVICE’S ABILITY TO
          WORK WITH THE APPLICATION, AND/OR THE APPLICTATION’S ABILITY TO
          RECONGINZE YOUR VOICE COMMAND IN A GIVEN CIRCUMSTANCE. IT IS SOLELY
          YOUR RESPONSIBILITY TO ENSURE THAT YOUR MOBILE DEVICE AND ITS
          CONNECTION IS SUFFICIENT AT ALL TIMES.
        </Text>
        <Text size="sm" py={10}>
          TO THE EXTENT PERMITTED BY APPLICABLE LAW, THE APPLICATION IS PROVIDED
          “AS IS,” WITHOUT WARRANTY OF ANY KIND, EITHER EXPRESS OR IMPLIED. SAY
          HELP DOES NOT GUARANTEE, REPRESENT, OR WARRANT THAT THE USE OF THE
          APPLICATION WILL BE UNINTERRUPTED, ERROR FREE, OR VIRUS FREE, OR THAT
          THE APPLICATION WILL MEET YOUR REQUIREMENTS. SAY HELP DISCLAIMS ALL
          WARRANTIES, EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO ANY
          WARRANTY OF TITLE, NON-INFRINGEMENT, MERCHANTABILITY, FITNESS FOR A
          PARTICULAR PURPOSE, OR ANY WARRANTY ARISING FROM A COURSE OF DEALING,
          TRADE USAGE, OR TRADE PRACTICE.
        </Text>

        <Title order={4} py={10}>
          Limitation of Liability
        </Title>
        <Text size="sm" py={10}>
          YOU ACKNOWLEDGE AND AGREE THAT YOUR USE OF THE APPLICATION IS AT YOUR
          SOLE RISK. NEITHER SAY HELP, NOR ANY OF ITS MEMBERS, MANAGERS,
          EMPLOYEES, AFFILIATES, AGENTS, REPRESENTATIVES, LICENSORS, SUCCESSORS,
          OR ASSIGNS (COLLECTIVELY, “SAY HELP ASSOCIATES”) SHALL BE LIABLE TO
          YOU FOR ANY COMPENSATORY, DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
          EXEMPLARY, PUNITIVE, OR CONSEQUENTIAL DAMAGES, OR ATTORNEYS’ FEES, OR
          FOR LOST DATA OR LOST PROFIT, ARISING OUT OF: (A) THE USE OF THE
          APPLICATION; (B) THE INABILITY TO GAIN ACCESS TO OR USE THE
          APPLICATION; AND/OR (C) SAY HELP’S BREACH OF THESE TERMS. THE
          FOREGOING EXCLUSIONS FROM LIABILITY SHALL BE APPLICABLE EVEN IF SAY
          HELP HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES OR SUCH
          DAMAGES WERE FORESEEABLE.
        </Text>
        <Text size="sm" py={10}>
          YOUR SOLE RIGHT AND REMEDY WITH RESPECT TO ANY DISPUTE WITH SAY HELP
          IS TO STOP USING THE APPLICATION. BECAUSE SOME STATES OR JURISDICTIONS
          DO NOT ALLOW THE EXCLUSION OR LIMITATION OF LIABILITY FOR
          CONSEQUENTIAL, INCIDENTAL OR SPECIAL DAMAGES, IN SUCH STATES AND
          JURISDICTIONS LIABILITY IS LIMITED TO THE GREATEST EXTENT PERMITTED BY
          LAW.
        </Text>

        <Title order={4} py={10}>
          Indemnification
        </Title>
        <Text size="sm" py={10}>
          You agree to indemnify, defend and hold harmless Say Help and the Say
          Help Associates from and against all losses, liabilities, expenses,
          damages, claims, demands and costs, including reasonable attorneys’
          fees and court costs, relating to or arising from: (a) any violation
          of this Terms by you; and (b) claims asserted by third parties, such
          as law enforcement, that result from your use of the Application.
        </Text>

        <Title order={4} py={10}>
          Privacy Policy
        </Title>
        <Text size="sm" py={10}>
          Say Help respects and is committed to your privacy. Please review Say
          Help’s{' '}
          <a
            href="https://sayhelp.com/privacy"
            target="_blank"
            rel="noreferrer">
            Privacy Policy
          </a>
          , which also governs your use of the Application, to understand Say
          Help’s practices.
        </Text>

        <Title order={4} py={10} align="left">
          Miscellaneous
        </Title>
        <Text size="sm" py={10}>
          The laws of the State of Wyoming shall govern the validity,
          performance, enforcement, interpretation and any other aspect of these
          Terms, without regard to principles of conflicts of laws thereunder.
          The parties agree to submit to the exclusive jurisdiction and venue of
          the courts of Johnson County, Wyoming for any action arising out of
          these Terms. Say Help shall be entitled to payment from you for any
          and all out-of-pocket costs, including, without limitation, attorneys'
          fees, incurred by Say Help in connection with enforcing these Terms.
        </Text>
        <Text size="sm" py={10}>
          You acknowledge and agree that the provisions, disclosures and
          disclaimers set forth in these Terms are fair and reasonable and your
          agreement to follow and be bound by them is not the result of fraud,
          duress or undue influence exercised upon you by any person or entity.
          The failure of Say Help to exercise or enforce any right or provision
          of these Terms shall not constitute a waiver of such right or
          provision. If any provision of these Terms is found by a court of
          competent jurisdiction to be invalid, the parties nevertheless agree
          that the court should endeavor to give effect to the parties’
          intentions as reflected in the provision, and the other provisions of
          the Terms shall remain in full force and effect.
        </Text>

        <Text size="sm" py={10}>
          Say Help shall have the right to assign these Terms and to sublicense
          any and all of its rights under these Terms. These Terms, including
          any documents referenced herein and any additional terms and
          conditions as posted via the Application, represent the entire
          understanding between you and Say Help regarding the Application.
          These Terms supersede all previous written or oral agreements between
          you and Say Help with respect to such subject matter. Notwithstanding
          any provision of these Terms, Say Help has available all remedies at
          law or equity to enforce these Terms.
        </Text>
        <Text size="sm" py={10}></Text>
      </Box>
    );
}

export default TosPlainText;

const useStyles = createStyles({
  container: {},
});
